import { timezones } from '@/utils/world-clock-timezones';

export function getTimezoneFromCountry(country: string | undefined) {
  return timezones.find((timezone) => timezone.label === country)?.name;
}
